import { createGlobalStyle } from 'styled-components';

export const BREAKPOINTS = {
  notebook: '1440px',
  tablet: '1024px',
  mobile: '428px',
} as const;

export const COLORS = {
  black: '#000',
  white: '#f8f8f8',
  grey: '#6E767A',
  lightgrey: '#D3D3D3',
  blue: '#0F3D4C',
  green: '#4BA69C',
  wpp: '#25D366',
} as const;

export const SPACING = {
  xs: '8px',
  sm: '16px',
  md: '32px',
  lg: '64px',
  xl: '128px',
} as const;

export const TRANSITIONS = {
  default: '0.2s',
  slow: '0.5s',
} as const;

const GlobalStyle = createGlobalStyle`
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    border: none;
    text-decoration: none;
    list-style: none;
    font-family: Roboto, sans-serif;
    transition: ${TRANSITIONS.default};
  }

  html, body {
    height: 100%;
    background: ${COLORS.white};
    scroll-behavior: smooth;
  }

  /* Screen reader only class for accessibility */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  /* Focus styles for accessibility */
  *:focus-visible {
    outline: 2px solid ${COLORS.green};
    outline-offset: 2px;
  }

  /* Skip to main content link for accessibility */
  .skip-to-main {
    position: absolute;
    top: -40px;
    left: 0;
    background: ${COLORS.blue};
    color: ${COLORS.white};
    padding: 8px 16px;
    text-decoration: none;
    z-index: 100;

    &:focus {
      top: 0;
    }
  }
`;

export default GlobalStyle;